import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "o-container" }
const _hoisted_2 = { class: "o-form" }
const _hoisted_3 = { class: "o-form__item__container" }
const _hoisted_4 = { class: "o-form__item" }
const _hoisted_5 = {
  class: "o-label sr-only",
  for: "cours-search"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-search",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "search"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search" })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "o-form__item" }
const _hoisted_9 = {
  class: "o-label sr-only",
  for: "codes"
}
const _hoisted_10 = { value: "" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_13 = { class: "o-form__item" }
const _hoisted_14 = {
  class: "o-label sr-only",
  for: "cycle"
}
const _hoisted_15 = { value: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_18 = { class: "o-form__button c-tooltip__wrap" }
const _hoisted_19 = {
  class: "o-button -button-bg",
  type: "submit"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-full-right"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-full-right"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_21 = { class: "o-button__text" }
const _hoisted_22 = { class: "o-button__text__elm" }
const _hoisted_23 = { class: "sr-only" }
const _hoisted_24 = { class: "c-tooltip" }
const _hoisted_25 = { class: "c-tooltip__text" }
const _hoisted_26 = { class: "c-programmes-search__filters" }
const _hoisted_27 = { class: "o-container" }
const _hoisted_28 = { class: "c-programmes-search__filters__wrap" }
const _hoisted_29 = { class: "c-programmes-search__filters__total" }
const _hoisted_30 = {
  key: 0,
  class: "c-programmes-search__filters__actives"
}
const _hoisted_31 = { class: "c-programmes-search__filters__actives__item" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "sr-only" }
const _hoisted_36 = { class: "c-programmes-search__filters__reset" }
const _hoisted_37 = { class: "o-container" }
const _hoisted_38 = {
  ref: "resultsStart",
  class: "c-projects-search__results"
}
const _hoisted_39 = { class: "c-search-results__item -show" }
const _hoisted_40 = { class: "c-search-result__header" }
const _hoisted_41 = { class: "c-search-result__title o-title-4" }
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "c-search-result__desc" }
const _hoisted_44 = { class: "c-search-result__tags" }
const _hoisted_45 = {
  key: 0,
  class: "o-tag"
}
const _hoisted_46 = {
  key: 1,
  class: "o-tag"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pager = _resolveComponent("Pager")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-programmes-search", [$props.background]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString($options.t("Mots clés")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                onKeyup: _cache[0] || (_cache[0] = $event => ($options.keyupSearch())),
                class: "o-input",
                id: "cours-search",
                type: "text",
                placeholder: $options.t("Mots clés"),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.searchInput) = $event))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                [_vModelText, $data.searchInput]
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString($options.t("Code")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[2] || (_cache[2] = $event => ($options.changeSelectionCode())),
                class: "o-select",
                id: "codes",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedCode) = $event))
              }, [
                _createElementVNode("option", _hoisted_10, _toDisplayString($options.t("Code")), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.codes, (code) => {
                  return (_openBlock(), _createElementBlock("option", { value: code }, _toDisplayString(code), 9 /* TEXT, PROPS */, _hoisted_11))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, $data.selectedCode]
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString($options.t("Cycle")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[4] || (_cache[4] = $event => ($options.changeSelectionCycle())),
                class: "o-select",
                id: "cycle",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedCycle) = $event))
              }, [
                _createElementVNode("option", _hoisted_15, _toDisplayString($options.t("Cycle")), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cycles, (cycle) => {
                  return (_openBlock(), _createElementBlock("option", { value: cycle }, _toDisplayString(cycle), 9 /* TEXT, PROPS */, _hoisted_16))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, $data.selectedCycle]
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createTextVNode(_toDisplayString($options.t("Rechercher")) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_23, _toDisplayString($options.t("un cour selon les critères sélectionnés")), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString($options.t("Voir les")) + " " + _toDisplayString($options.filteredResults.length) + " " + _toDisplayString($options.t("résultat")) + _toDisplayString($options.filteredResults.length > 1 ? 's' : ''), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", null, _toDisplayString($options.filteredResults.length) + " " + _toDisplayString($options.t("résultat")) + _toDisplayString($options.filteredResults.length > 1 ? 's' : ''), 1 /* TEXT */)
          ]),
          ($options.tags.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("span", null, _toDisplayString(tag.title), 1 /* TEXT */),
                    _createElementVNode("button", {
                      onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"]),
                      class: "c-programmes-search__filters__remove"
                    }, [
                      _hoisted_33,
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString($options.t("Retirer le filtre")) + " : " + _toDisplayString(tag.title), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_32)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = _withModifiers($event => ($options.resetSearch()), ["prevent"])),
              class: "o-button -button-reset"
            }, _toDisplayString($options.t("Réinitialiser la recherche")), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["o-section__inner", {'-loading': $data.loading}])
    }, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredResultsPaged, (entry) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, [
                  _createElementVNode("a", {
                    href: entry.url
                  }, _toDisplayString(entry.code) + " - " + _toDisplayString(entry.title), 9 /* TEXT, PROPS */, _hoisted_42)
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("p", null, _toDisplayString(entry.description), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_44, [
                (entry.code)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(entry.code.replace(/<[^>]*>?/gm, '')), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (entry.cycle)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(entry.cycle.replace(/<[^>]*>?/gm, '')), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */),
        ($data.pagerInfo.totalPages>1)
          ? (_openBlock(), _createBlock(_component_Pager, {
              key: 0,
              pagerInfo: $data.pagerInfo,
              onGoToPage: $options.goToPage
            }, null, 8 /* PROPS */, ["pagerInfo", "onGoToPage"]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}